module.exports = __webpack_public_path__ + "static/img/our-awards_1.a57c106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_1.png
// module id = FYNr
// module chunks = 0